import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=f9b9f98a&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style1 from "./Question.vue?vue&type=style&index=1&id=f9b9f98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b9f98a",
  null
  
)

export default component.exports